import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../../Univ.js'

function Insulin(props){

  const {ip_id} = useParams();
  const [ipData, setIpData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [insulinData, setinsulinData] = useState([]);
  const [nurseData,setnurseData]=useState({
        "ip":'',
        "fluid":'',
        "drug":'',
        "units":'',
        "drops":'',
        "ins":'',
        "bls":'',
        "blstype":'',
        "insulin_time":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
   const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };

   useEffect(() => {
        fetchinsulinData();
   }, []);
    function fetchinsulinData() {
      axios.get(baseUrl + "view-insulin/" + ip_id + "/")
        .then(response => {
          setinsulinData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }

  const formSubmit = (e) => {
      e.preventDefault();
         const fluid = document.getElementById("fluid").value;
         const drug = document.getElementById("drug").value;
         const units = document.getElementById("units").value;
         const drops = document.getElementById("drops").value;
         const ins = document.getElementById("ins").value;
         const bls = document.getElementById("bls").value;
         const blstype = document.getElementById("blstype").value;
         const insulin_time = document.getElementById("insulin_time").value;
          const _formData = new FormData();
          _formData.append('ip', ip_id);
          _formData.append('fluid', fluid);
          _formData.append('drug', drug);
          _formData.append('units', units);
          _formData.append('drops', drops);
          _formData.append('ins', ins);
          _formData.append('bls', bls);
          _formData.append('blstype', blstype);
          _formData.append('insulin_time', insulin_time);
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}insulin-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Insulin Details Updated Succesfully',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setnurseData({
                  ip: '',
                  notes: '',
                  insulin_time: '',
                  status: '',
                  addedby: '',
                  ip_add: '',
                });
                setTimeout(() => {
                  window.location.href = '/nurse-pat-view/'+ ip_id +'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed. Please try again later.',
                'error'
              );
            });
  };
  const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-insulin/'+id+'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                    window.location.href = ('/insulin/'+ip_id+'/');
                    }, 3000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }

    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{ color: 'red' }}></i>
      Primary Consultant -  Dr.{ipData.map(row => row.primary_consult.consultant)}
    </h3>
     <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip_id}</td>
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{formatDateTime(patientData.admit_date)}</td>
          </tr>
        ))}
      </tbody>
        </table>
     </div>
  <div >
  <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-syringe" aria-hidden="true" style={{ color: 'red' }}></i>
      Insulin Details
    </h3>
      <form>
      <div className="row">
        <div className="col-md-2">
          <label htmlFor="Tempr" className="form-label">Fluid: </label>
          <select className="form-control"
                name="fluid" id="fluid" >
                <option >Select</option>
                <option value="100 ml">100 ml</option>
                <option value="500 ml">500 ml</option>
          </select>
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="" className="form-label">Drug : </label>
          <input
            type="text"
            className="ms-1 form-control"
            name="drug"
            id="drug"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Units : </label>
          <input
            type="number"
            className="ms-1 form-control"
            name="units"
            id="units"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Drops : </label>
          <input
            type="text"
            className="ms-1 form-control"
            name="drops"
            id="drops"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">INS units/Hrs : </label>
          <input
            type="text"
            className="ms-1 form-control"
            name="ins"
            id="ins"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Blood Sugar : </label>
          <input
            type="text"
            className="ms-1 form-control"
            name="bls"
            id="bls"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Tempr" className="form-label">Blood Sugar Type: </label>
          <input
            type="text"
            className="ms-1 form-control"
            name="blstype"
            id="blstype"
          />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Notes Time" className="form-label">Notes Time : </label>
          <DatePicker className="form-control" name="insulin_time" id="insulin_time" selected={selectedDateTime}
                            onChange={handleDateTimeChange}
                            dateFormat="yyyy-MM-dd h:mm"
                            showTimeSelect
                            timeIntervals={15}
                            timeCaption="Time"
                        />
        </div>
       </div>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5 mb-5' >
          <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
        </div>
      </form>
              <div className="card card-body">
              <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa-solid fa-syringe" aria-hidden="true" style={{ color: 'red' }}></i>
                  Insulin History
                    </h3>
               <div className="table-responsive">
              <table className="erp-table-modern">
              <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                      <th>Date</th>
                      <th colSpan="6">Insulin Details</th>
                      <th>Delete</th>
                    </tr>
              </thead>
              <tbody>
                {insulinData.map((dis, index) => (
                      <tr >
                        <td>{formatDateTime(dis.insulin_time)}</td>
                        <td>Fluid : {dis.fluid}</td>
                        <td>Drug - Units: {dis.drug} - {dis.units}</td>
                        <td>Drops: {dis.drops}</td>
                        <td>INS : {dis.ins}</td>
                        <td>Blood Sugar : {dis.bls}</td>
                        <td>Sugar Type : {dis.blstype}</td>
                        <td>
                          <button className="btn btn-danger" type="button" onClick={() => handleDelete(dis.id)}>
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
                </table>
              </div>
              </div>
    </div>
    </section>
    )
}

export default Insulin;